import { ArrowUpRightIcon } from '@popsure/dirty-swan';
import classNames from 'classnames';
import { useTranslation } from 'next-i18next';

import styles from './TrustpilotFallback.module.scss';

interface TrustpilotFallbackProps {
  height: number;
}

export const TrustpilotFallback = ({ height }: TrustpilotFallbackProps) => {
  const { t } = useTranslation();

  return (
    <a
      href="https://www.trustpilot.com/review/feather-insurance.com"
      target="_blank"
      rel="noopener noreferrer"
      className={classNames('d-flex ai-center p-a fw-bold', styles.fallback)}
      style={{ height: `${height}px` }}
    >
      {t('trustpilotWidget.link', 'Trustpilot reviews')}
      <ArrowUpRightIcon
        noMargin
        size={20}
        className={classNames(styles.icon)}
      />
    </a>
  );
};
